import { render, staticRenderFns } from "./SystemMangement.vue?vue&type=template&id=13194220&scoped=true&"
import script from "./SystemMangement.vue?vue&type=script&lang=js&"
export * from "./SystemMangement.vue?vue&type=script&lang=js&"
import style0 from "./SystemMangement.vue?vue&type=style&index=0&id=13194220&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13194220",
  null
  
)

export default component.exports